
export type PostApiV1RefundsCancelSubscription200AllOfThree = {
  /** 취소 완료 메시지 */
  data?: string;
};
